<template>
    <div>
        <m-assembly-table ref='pageForm'
            :formData='formData'
            :columns='columns'
            :data='tableData'
            :tableButtons='tableButtons'
            :loading='loading'
            :currentPage='settings.currentPage'
            :pageSize='settings.pageSize'
            :total='settings.total'
            :settings='settings'
            @onSubmit='onSubmit'
            @onPageSizeChange='onPageSizeChange'
            @onCurrentPageChange='onPageChange'
            @onSelectionChange="onSelectionChange"
        >
        </m-assembly-table>
    </div>
</template>
<script>
import axios from 'axios';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
import {dateTimeChange, exportExcel} from './financialAccounting';
export default {
    name: 'fpzInvaccSearch',
    components: { 
        mAssemblyTable 
    },
    data () {
        return {
            formData: {
                row: 1,
                items: [
                    {
                        value: '',
                        field: 'organizationCode', // 库存组织
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {
                            change: (val) => {
                                // if (val) {
                                //     getVendorSite(this.orgList.find((item) => item.value === val).erpOrgId, this, (data) => {
                                //         data = [
                                //             {
                                //                 label: 'E01009069001B',
                                //                 value: 'E01009069001B'
                                //             }
                                //         ];
                                //         this.getFormDataItemObj(this.formData.items, 'vendorSiteCode').options.values = data;
                                //     });
                                // }
                            }
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('fpzInvaccSearch.t1'),
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('common.not_empty_require')
                            }
                        }
                    },
                    // {
                    //     value: '',
                    //     field: 'vendorSiteCode', // 供应商地点
                    //     disabled: false,
                    //     layout: {
                    //         span: 8,
                    //         offset: 0,
                    //         row: 1
                    //     },
                    //     methods: {},
                    //     options: {
                    //         multiple: false,
                    //         values: []
                    //     },
                    //     type: 'select',
                    //     title: this.$t('fpzInvaccSearch.t2'),
                    //     validators: {
                    //         required: {
                    //             required: true,
                    //             message: this.$t('common.not_empty_require')
                    //         }
                    //     }
                    // },
                    {
                        value: '',
                        field: 'status', // 状态
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {},
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('fpzInvaccSearch.t3')
                    }
                ]
            },
            columns: {
                columns: [
                    {
                        title: this.$t('fpzInvaccSearch.t4'), // 明细
                        align: 'center',
                        minWidth: 40,
                        render: (h, params) => {
                            return h('Button', {
                                props: {
                                    size: 'small',
                                    icon: 'm-icon m-icon-ios-list-outline'
                                },
                                on: {
                                    click: () => {
                                        let {headerId, ATTRIBUTE1} = params.row;
                                        this.$router.push({
                                            name: 'fpzInvaccDetail', 
                                            query: {
                                                id: headerId, 
                                                orgId: ATTRIBUTE1
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('fpzInvaccSearch.t5'), // 对账单号
                        align: 'center',
                        minWidth: 110,
                        key: 'invaccNum'
                    },
                    {
                        title: this.$t('fpzInvaccSearch.t6'), // 期间从
                        align: 'center',
                        minWidth: 70,
                        key: 'periodFrom'
                    },
                    {
                        title: this.$t('fpzInvaccSearch.t7'), // 期间至
                        align: 'center',
                        minWidth: 70,
                        key: 'periodTo'
                    },
                    {
                        title: this.$t('fpzInvaccSearch.t8'), // 对账状态
                        align: 'center',
                        minWidth: 90,
                        key: 'status',
                        render: (h, params) => {
                            let {status} = params.row;
                            return h('span', status && this.INT_RECONCILIATION_STATUS.find((item) => item.value === status).label);
                        }
                    },
                    {
                        title: this.$t('fpzInvaccSearch.t9'), // 拒绝原因
                        align: 'center',
                        minWidth: 200,
                        key: 'description'
                    },
                    {
                        title: this.$t('fpzInvaccSearch.t10'), // 供应商确认日期
                        align: 'center',
                        minWidth: 140,
                        key: 'supplierDate',
                        render: (h, params) => {
                            let {supplierDate} = params.row;
                            let {organizationCode} = this.getFormDataVModel(this.formData.items);
                            return h('span', supplierDate ? dateTimeChange(supplierDate, organizationCode, this) : '');
                        }
                    },
                    {
                        title: this.$t('fpzInvaccSearch.t11'), // 删除
                        align: 'center',
                        key: 'status',
                        minWidth: 60,
                        render: (h, params) => {
                            let {headerId, status, periodFrom, periodTo} = params.row;
                            let disabled = !['NEW', 'REJECT'].includes(status);
                            return h('Button', {
                                props: {
                                    type: 'text',
                                    icon: 'trash-b',
                                    disabled
                                },
                                on: {
                                    click: () => {
                                        this.deleteLine(headerId, periodFrom, periodTo);
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('fpzInvaccSearch.t16'), // 对账函
                        align: 'center',
                        key: 'PRINT_FLAG',
                        minWidth: 60,
                        render: (h, params) => {
                            return h('Button',
                                {
                                props: {
                                    type: 'text',
                                    icon: 'printer',
                                    loading: this.printLoading
                                },
                                on: {
                                    click: () => {
                                        let {headerId, orgId} = params.row;
                                        this.print(headerId, orgId);
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('fpzInvaccSearch.t18'), // 附件
                        align: 'center',
                        minWidth: 230,
                        render: (h, params) => {
                            let format = ['jpeg', 'jpg', 'png', 'gif', 'pdf', 'rar', 'zip', '7z'];
                            let {headerId, status, accessoryUrl, accessoryName} = params.row;
                            let disabled = !['NEW', 'REJECT'].includes(status);
                            let upload = h('Upload', {
                                props: {
                                    action: '/gscint/supplierfile/uploadFile',
                                    format,
                                    showUploadList: false,
                                    onSuccess: (response, file) => {
                                        let {fileName, docId} = response.data;
                                        axios.post('/gscint/hw/invacc/uploadFile', {
                                            accessoryName: fileName,
                                            accessoryUrl: docId,
                                            headerId: headerId,
                                            vendorCode: this.vendorCode
                                        }).then(res => {
                                            if (res.data.success) {
                                                this.$Modal.success({
                                                    content: this.$t('fpzInvaccSearch.t19') // 上传成功
                                                });
                                                this.onSubmit();
                                            } else {
                                                this.showErrorTips('loading', res.data.msg);
                                            }
                                        });
                                    },
                                    onFormatError: () => {
                                        this.$Modal.error({
                                            // 附件只支持 xxx 格式
                                            content: `${this.$t('fpzInvaccSearch.t20')}${format.join()}${this.$t('fpzInvaccSearch.t21')}`
                                        });
                                    }
                                }
                            },
                            [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        icon: 'upload',
                                        disabled
                                    }
                                })
                            ]);
                            if (!accessoryUrl) {
                                return upload;
                            } else {
                                return h('div', {}, [
                                    h('a', {
                                        attrs: {
                                            href: `/gscint/supplierfile/downloadFile?docId=${accessoryUrl}`
                                        }
                                    }, [accessoryName]),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            icon: 'close',
                                            disabled
                                        },
                                        on: {
                                            click: () => {
                                                this.$Modal.confirm({
                                                    content: this.$t('fpzInvaccSearch.t22'), // 是否删除附件？
                                                    onOk: () => {
                                                        const url = '/gscint/hw/invacc/uploadFile';
                                                        axios.post(url, {
                                                            accessoryName,
                                                            accessoryUrl,
                                                            headerId,
                                                            vendorCode: this.vendorCode,
                                                            uploadFlag: 'del'
                                                        })
                                                        .then(res => {
                                                            if (res.data.data.success) {
                                                                setTimeout(() => {
                                                                    this.$Modal.success({
                                                                        content: this.$t('fpzInvaccSearch.t23') // 删除成功
                                                                    });
                                                                }, 500);
                                                                this.onSubmit();
                                                            }
                                                        })
                                                        .catch(() => {
                                                            this.showErrorTips();
                                                        });
                                                    }
                                                });
                                            }
                                        }
                                    })
                                ]);
                            }
                        }
                    },
                    {
                        title: this.$t('fpzInvaccSearch.t24'), // 确认按钮
                        align: 'center',
                        key: 'status',
                        minWidth: 60,
                        render: (h, params) => {
                            let {status, headerId} = params.row;
                            let disabled = !['NEW', 'REJECT'].includes(status);
                            return h('Button',
                                {
                                props: {
                                    type: 'text',
                                    icon: 'checkmark',
                                    disabled,
                                    loading: this.lineLoading
                                },
                                style: {
                                    fontSize: '16px',
                                    color: disabled ? '#bbbec4' : '#2d8cf0'  
                                },
                                on: {
                                    click: () => {
                                        this.confirm(headerId, params.row)
                                        .then(() => {
                                            this.lineLoading = false;
                                        })
                                        .catch(() => {
                                            this.lineLoading = false;
                                        });
                                    }
                                }
                            });
                        }
                    }
                ]
            },
            tableData: [],
            tableButtons: {
                customButtons: [
                    {
                        label: this.$t('fpzInvaccSearch.t26'),
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: false,
                        size: 'small',
                        click: (button) => {
                            this.$router.push({
                                name: 'fpzInvaccAdd'
                            });
                        }
                    },
                    {
                        label: this.$t('fpzInvaccSearch.t27'),
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: false,
                        size: 'small',
                        click: (button) => {
                            if (this.$refs.pageForm.$children[0].$children[0].validateForm()) {
                                this.$set(button, 'loading', true);
                                exportExcel(button, this, this.getFormDataVModel(this.formData.items), '/gscint/hw/invacc/exportHeaders');
                            }
                        }
                    }
                ],
            },
            loading: false,
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 20, 50, 100],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: null,
                submitLoading: false
            },
            selection: [],
            INT_RECONCILIATION_STATUS: [],
            orgList: [],
            printLoading: false,
            lineLoading: false
        }
    },
    methods: {
        confirm(headerId, {accessoryUrl, accessoryName}) {
            if (!accessoryUrl || !accessoryName) {
                this.$Modal.warning({
                    content: this.$t('fpzInvaccCommon.t37')
                })
                return false;
            }
            this.lineLoading = true;
            return axios.post('/gscint/hw/invacc/confirm', {
                vendorCode: this.vendorCode,
                headerId
            })
            .then(res => {
                let {code} = res.data.data;
                if (code !== -1) {
                    this.$Modal.success({
                        content: this.$t('fpzInvaccSearch.t25')
                    });
                    this.onSubmit();
                } else {
                    this.showErrorTips();
                }
            })
            .catch(() => {
                this.showErrorTips();
            })
        },
        deleteLine (headerId, from, to) {
            this.$Modal.confirm({
                // 确定要删除对账期间 from 到 to 的对账单吗？
                content: `<p>${this.$t('fpzInvaccSearch.t12')}${from}${this.$t('fpzInvaccSearch.t13')}${to}${this.$t('fpzInvaccSearch.t14')}</p>`,
                onOk: () => {
                    axios.post('/gscint/hw/invacc/delete', {
                        vendorCode: this.vendorCode,
                        headerId
                    }).then(res => {
                        if (res.data.success) {
                            this.onSubmit();
                            setTimeout(() => {
                                this.$Modal.success({
                                    content: this.$t('fpzInvaccSearch.t15')
                                });
                            }, 500);
                        } else {
                            setTimeout(() => {
                                this.showErrorTips('loading', res.data.msg);
                            }, 500);
                        }
                    })
                    .catch(() => {
                        this.showErrorTips();
                    });
                }
            });
        },
        print(headerId, orgId) {
            let supplierInfo = JSON.parse(localStorage.getItem('supplierInfo'));
            axios.post('/gscint/hw/invacc/queryForPrint', {
                vendorCode: this.vendorCode,
                headerId,
                orgId
            })
            .then((res) => {
                let {data, code, message} = res.data.data;
                if (code === 1) {
                    this.cloudPrint('invaccReport-hw', {reportlets: {
                        printUser: supplierInfo && supplierInfo.userName,
                        ...data
                    }})
                    .then(() => {
                    this.printLoading = false;
                    })
                    .catch(() => {
                        this.printLoading = false;
                    });
                } else {
                    this.showErrorTips('printLoading', message);
                }
            })
            .catch(() => {
                this.showErrorTips('printLoading');
            });
        },
        str2camel(str) {
            str = str.toLowerCase();
            let newStr = '';
            for (let i = 0; i < str.length; i++) {
            if (str[i] === '_') {
                i++;
                if (str[i]) {
                newStr += str[i].toUpperCase();
                }
                continue;
            }
            newStr += str[i];
            }
            return newStr;
        },
        onSubmit () {
            this.loading = true;
            axios.post('/gscint/hw/invacc/queryHeaders', {
                ...this.getFormDataVModel(this.formData.items),
                vendorCode: this.vendorCode,
                pageNum: this.settings.currentPage,
                pageSize:  this.settings.pageSize
            })
            .then(res => {
                this.loading = false;
                let {list, total} = res.data.data;
                this.tableData = list;
                this.settings.total = total;
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        onPageSizeChange (currentPage, pageSize) {
            this.settings.currentPage = 1;
            this.settings.pageSize = pageSize;
            this.onSubmit();
        },
        onPageChange (currentPage, pageSize) {
            this.settings.currentPage = currentPage;
            this.onSubmit();
        },
        onSelectionChange (selection) {
            this.selection = selection;
        }
    },
    mounted() {
        // this.getUserBaseInfo((res) => {
        //     let {vendorId, vendorCode} = res.data.data;
        //     this.vendorId = vendorId;
        //     this.vendorCode = vendorCode;
        // });
        this.getSRMInvLovListNew((data) => {
            const orgList = data.map((item) => {
                return {
					...item,
                    label: item.organizationName,
                    value: item.organizationCode,
                };
            });
            this.orgList = orgList;
            this.getFormDataItemObj(this.formData.items, 'organizationCode').options.values = orgList;
        });
        this.getDict('INT_RECONCILIATION_STATUS', (data) => {
            this.getFormDataItemObj(this.formData.items, 'status').options.values = data.filter((item) => item.email !== 'N');
        });
    },
}
</script>